export default __webpack_public_path__ + "static/media/game-icon.1afccebc.png";